import React,{useState,useEffect} from 'react'
import {Container,AppBar, Typography, Grow, Grid} from '@material-ui/core';
import Posts from '../Posts/Posts'
import Form from '../Form/Form';
import useStyles from './styles';
//to dispatch an action
import {useDispatch} from 'react-redux';
//importing action
import {getPosts} from '../../actions/posts';
function Home() {
    const classes = useStyles();
    const[currentId, setcurrentId] = useState(null);
     {/* define dispatch*/}
    const dispatch = useDispatch();
      {/* best way to call dispatch is inside useEffect*/}
    useEffect(()=>{
        dispatch(getPosts()); //getPosts action taken
    },[currentId,dispatch]);
    console.log("current id: ",currentId);
    return (
        <div>
            <Grow in>
                <Container>
                    <Grid className={classes.mainContainer} container justify="space-between" alignItems="stretch" spacing={3}>
                        <Grid item xs={12} sm={7}>
                        <Posts setcurrentId={setcurrentId}/>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                        <Form currentId={currentId} setcurrentId={setcurrentId}/>
                        </Grid>
                    </Grid>
                </Container>
            </Grow>
        </div>
    )
}

export default Home
